// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___d2e9053c530943bfd3a","cls2":"ImpactHubModal-cls2___dbfcd555ac0168bbc75 ImpactHubModal-cls1___d2e9053c530943bfd3a"};